import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const proformaExportRoute: InvariantJiraRoute = {
	name: 'proforma-export',
	path: '/jira/forms/export',
	exact: true,
};
